var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connector-template"},[_vm._v("connector-template")])
}
var staticRenderFns = []

export { render, staticRenderFns }